// extracted by mini-css-extract-plugin
export default {"title":"PvjTCExHA0yCprchYNHP"};